module.exports = __webpack_public_path__ + "/bundle/asset/exam-1-b5e6ae5eb5eae3ead517f00e35f22bbc.png";